/**
 * The site shell around a guide page.
 *
 * The thirteen guides each had their own 49px strip with a back link and an
 * "AI Tools →" link, and no footer at all. Thirteen near-identical strips, and
 * none of them carried the wordmark, the Resource Center link, the account
 * control, or any way to reach the rest of the site. A visitor who landed on a
 * guide from an email had no signal they were on Your Smart Stack.
 *
 * The back link was the one genuinely useful thing those strips had, so it
 * survives — handed to SiteHeader, which renders it inside the sticky element.
 * It used to be a row here, underneath the header, which meant it scrolled
 * away; on pages this long that is the same as not having it.
 */

import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";

export default function GuideShell({
  context,
  backHref,
  backLabel,
  children,
}: {
  /** Shown in the header's context slot, e.g. "Claude guide". */
  context?: string;
  backHref?: string;
  backLabel?: string;
  children: React.ReactNode;
}) {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <SiteHeader context={context} backHref={backHref} backLabel={backLabel} />

      <main className="flex-1">{children}</main>

      <SiteFooter />
    </div>
  );
}
